import {
  AddStationFormFieldsEnum,
  IPassengersMapLocationInfo,
  yupLocalized,
} from "@ryde/shared";

export const yupAddStationValidationSchema = {
  [AddStationFormFieldsEnum.Addresses]: yupLocalized
    .object<IPassengersMapLocationInfo>()
    .shape({
      fullAddress: yupLocalized.string().required(),
      latitude: yupLocalized.number().nullable().optional(),
      longitude: yupLocalized.number().nullable().optional(),
    })
    .optional(),
};
